module.exports = __webpack_public_path__ + "static/media/jameson.5d5c9fb6.png";